import React, { forwardRef } from "react";
import AceEditor from "react-ace";
import { useTheme } from "@/components/ThemeProvider";

import "./AceEditorInput.less";

function AceEditorInput(props, ref) {
  const { isDarkMode } = useTheme();

  return (
    <div className={`ace-editor-input ${isDarkMode ? 'dark-mode' : ''}`} data-test={props["data-test"]}>
      <AceEditor
        ref={ref}
        mode="sql"
        theme={isDarkMode ? "tomorrow_night" : "gruvbox"}
        height="100px"
        editorProps={{ $blockScrolling: Infinity }}
        showPrintMargin={false}
        {...props}
      />
    </div>
  );
}

export default forwardRef(AceEditorInput);
